import BrandliveLogoOld from '@/images/BrandLive_Logo.svg?react';

const BrandliveLogo: React.FC<unknown> = () => {
  return <BrandliveLogoOld height="48px" />;
};

export default BrandliveLogo;
